// extracted by mini-css-extract-plugin
export default {"layout":"app_layout_layout__YWqQn","header":"app_layout_header__YGyAt","footer":"app_layout_footer__GSqtV","content":"app_layout_content__Jgit2"};